import { useState, useEffect } from 'react';

/**
 * Clock data interface
 */
export interface ClockData {
  time: string;
  timeLabel: string;
  date: string;
}

/**
 * Custom React hook for real-time clock
 */
export function useClock(): ClockData {
  const [clockData, setClockData] = useState<ClockData>(() => {
    const now = new Date();
    return formatClockData(now);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setClockData(formatClockData(now));
    }, 1000); // Update every second

    return () => clearInterval(interval);
  }, []);

  return clockData;
}

/**
 * Format date to clock data
 */
function formatClockData(date: Date): ClockData {
  // Get time in 12-hour format
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const timeLabel = hours >= 12 ? "PM" : "AM";
  
  // Convert to 12-hour format
  hours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  
  // Format time with leading zeros
  const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  
  // Format date as "05 Sep 2025"
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const dateStr = `${day} ${month} ${year}`;
  
  return {
    time,
    timeLabel,
    date: dateStr
  };
}